var $05970119863e3cb1$exports = {};
$05970119863e3cb1$exports = {
    "colorFormat": `Format de couleur`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `TSL`,
    "rgb": `RVB`
};


export {$05970119863e3cb1$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
